<template>
  <transition
    @before-appear="beforeEnter"
    @before-enter="beforeEnter"
    @appear="enter"
    @enter="enter"
    @leave="leave"
    :css="false"
  >
    <div>
      <slot v-if="showChildren" />
    </div>
  </transition>
</template>

<script>
import { TweenMax } from "gsap";

export const ENTER_DURATION = 0.75;
export const LEAVE_DURATION = 0.5;

export default {
  data: () => ({
    showChildren: false,
  }),
  methods: {
    beforeEnter(el) {
      TweenMax.set(el, { alpha: 0, display: "none" });
    },
    enter(el, done) {
      TweenMax.set(el, {
        display: "block",
        delay: LEAVE_DURATION,
      });
      TweenMax.to(el, ENTER_DURATION, {
        alpha: 1,
        delay: LEAVE_DURATION,
        onComplete: done,
        onStart: () => {
          this.showChildren = true;
        },
      });
    },
    leave(el, done) {
      TweenMax.to(el, LEAVE_DURATION, {
        autoAlpha: 0,
        onComplete: () => {
          this.showChildren = false;
          done();
        },
      });
    },
  },
};
</script>
